import { render, staticRenderFns } from "./ToolbarItem.vue?vue&type=template&id=a83c2f38&scoped=true"
import script from "./ToolbarItem.vue?vue&type=script&lang=ts"
export * from "./ToolbarItem.vue?vue&type=script&lang=ts"
import style0 from "./ToolbarItem.vue?vue&type=style&index=0&id=a83c2f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83c2f38",
  null
  
)

export default component.exports